module.exports = __webpack_public_path__ + "f86e826aa3b99464010572c65fe02779.svg";